// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__ZLS+r","success":"Notification_success__7SWP1","error":"Notification_error__tijZb","closeButton":"Notification_closeButton__9jYhR"};